import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { toast } from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import DataApi from '../../../api/data/DataApi'
import { HttpError } from '../../../types/common'
import { showErrorToast } from '../../../utils/errors'

const dataApi = DataApi.getInstance()

export function useResendEmailVerification() {
  const texts = useTranslation().t

  const mutation = useMutation(async (email: string) => {
    const { data } = await dataApi.resendEmailVerification(email)
    return data
  }, {
    onSuccess: () => {
      toast.success(texts('successes:verification_email_sent'))
    },
    onError: (error: AxiosError<HttpError>) => {
      showErrorToast(error, texts)
    }
  })
  return mutation
}